import { defineStore } from 'pinia';
import cloneDeep from 'lodash/cloneDeep';
import useMenusStore from './menus';

const useRoutesStore = defineStore('routesStore', {
    state: () => ({
        routes: [] // 路由
    }),
    actions: {
        setRoutes(routes) {
            this.routes = routes;
            useMenusStore().setMenus(cloneDeep(routes));
        }
    }
});

export default useRoutesStore;
